var map = {
	"./Liferay.png": 4716,
	"./Myson.png": 9453,
	"./Neural.png": 2119,
	"./Orca.png": 9442,
	"./Sisnet.png": 6794,
	"./Telin.png": 1051,
	"./ecouncil.png": 5029,
	"./logo-orca.png": 6651,
	"./logo-sobot.png": 4952,
	"./noname.png": 8727,
	"./proofpoint.png": 6386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9687;